import React, { useEffect, useRef } from 'react';
import './SmartContextMenu.css';

const SmartContextMenu = ({ 
  show, 
  x, 
  y, 
  onClose, 
  children 
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!show || !menuRef.current) return;

    const menu = menuRef.current;
    const menuRect = menu.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // Calculate available space below and above
    const spaceBelow = windowHeight - y;
    const spaceAbove = y;
    
    // Get the computed position
    let computedY = y;
    
    // If not enough space below and more space above, position above click
    if (spaceBelow < menuRect.height && spaceAbove > menuRect.height) {
      computedY = y - menuRect.height;
    }
    
    // Ensure menu stays within viewport bounds
    if (computedY + menuRect.height > windowHeight) {
      computedY = windowHeight - menuRect.height - 8; // 8px padding
    }
    if (computedY < 0) {
      computedY = 8; // 8px padding from top
    }
    
    // Apply the computed position
    menu.style.top = `${computedY}px`;
    menu.style.left = `${x}px`;
  }, [show, x, y]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (show && menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      ref={menuRef}
      className="context-menu show"
      style={{ position: 'fixed' }}
    >
      {children}
    </div>
  );
};

export default SmartContextMenu;